var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"app-user-header"},[_c('div',{staticClass:"left-arrow-wrapper",on:{"click":() => { this.$emit('left-arrow-click') }}},[_c('IconLeftArrow')],1),_c('img',{attrs:{"src":_vm.logoSrc,"width":"150"},on:{"click":() => { this.$emit('logo-click') }}})])
}
var staticRenderFns = []

export { render, staticRenderFns }